import { Checkbox, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const ChemistryViolationsHeader = ({
  multipleSamples,
  finalSampleOnly,
  setFinalSampleOnly,
}: {
  multipleSamples: boolean;
  finalSampleOnly: boolean;
  setFinalSampleOnly: (finalSampleOnly: boolean) => void;
}) => {
  const { t } = useTenantTranslation();

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFinalSampleOnly(event.target.checked);
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={"space-between"}
      gap={1}
    >
      <Typography variant="body2" color="text.secondary">
        {t("chemistryViolations")}
      </Typography>
      {multipleSamples ? (
        <Stack direction="row" alignItems="center">
          <Checkbox
            checked={finalSampleOnly}
            onChange={handleToggle}
            size="small"
            sx={{ width: 30, height: 30 }}
          />
          <Typography variant="body2" color="text.secondary">
            {t("onlyFinal")}
          </Typography>
        </Stack>
      ) : null}
    </Stack>
  );
};
